export const sequences2033 = [
  ['ate', 'rate', 'cater', 'racket'],
  ['tea', 'rate', 'crate', 'carpet'],
  ['eat', 'east', 'feast', 'safety'],
  ['ear', 'read', 'cedar', 'scared'],
  ['are', 'dare', 'tread', 'hatred'],
  ['ate', 'rate', 'extra', 'baxter'],
  ['tea', 'fate', 'fated', 'farted'],
  ['eat', 'fate', 'after', 'father'],
  ['ear', 'real', 'layer', 'lawyer'],
  ['are', 'gear', 'marge', 'mirage'],
  ['ate', 'seat', 'yeast', 'stayed'],
  ['tea', 'take', 'steak', 'streak'],
  ['eat', 'meat', 'meant', 'inmate'],
  ['ear', 'rate', 'mater', 'market'],
  ['are', 'earl', 'relay', 'nearly'],
  ['ate', 'tale', 'latte', 'talent'],
  ['tea', 'tear', 'cater', 'carpet'],
  ['eat', 'gate', 'grate', 'gather'],
  ['ear', 'care', 'crane', 'cancer'],
  ['are', 'wear', 'swear', 'answer'],
  ['ate', 'tear', 'tread', 'dreamt'],
  ['tea', 'late', 'latte', 'talent'],
  ['eat', 'beat', 'bathe', 'breath'],
  ['ear', 'tear', 'trade', 'dreamt'],
  ['are', 'bear', 'break', 'banker'],
  ['ate', 'tear', 'treat', 'target'],
  ['tea', 'seat', 'stale', 'lasted'],
  ['eat', 'rate', 'alter', 'learnt'],
  ['ear', 'read', 'armed', 'admire'],
  ['are', 'care', 'recap', 'preach'],
  ['ate', 'seat', 'steak', 'casket'],
  ['tea', 'tear', 'tread', 'dreamt'],
  ['eat', 'tear', 'terra', 'rather'],
  ['ear', 'hear', 'heart', 'father'],
  ['are', 'rate', 'later', 'travel'],
  ['ate', 'date', 'tread', 'dreamt'],
  ['tea', 'tale', 'delta', 'detail'],
  ['eat', 'tear', 'stare', 'faster'],
  ['ear', 'tear', 'grate', 'garret'],
  ['are', 'rate', 'water', 'wreath'],
  ['ate', 'tale', 'plate', 'planet'],
  ['tea', 'rate', 'alert', 'albert'],
  ['eat', 'tear', 'alert', 'travel'],
  ['ear', 'dare', 'armed', 'framed'],
  ['are', 'earl', 'pearl', 'player'],
  ['ate', 'late', 'steal', 'latest'],
  ['tea', 'meat', 'mater', 'market'],
  ['eat', 'team', 'tamed', 'dreamt'],
  ['ear', 'tear', 'treat', 'target'],
  ['are', 'year', 'ready', 'prayed'],
  ['ate', 'date', 'cadet', 'coated'],
  ['tea', 'meat', 'meant', 'inmate'],
  ['eat', 'late', 'delta', 'detail'],
  ['ear', 'gear', 'sarge', 'grease'],
  ['are', 'tear', 'after', 'fatter'],
  ['ate', 'seat', 'steal', 'castle'],
  ['tea', 'tear', 'grate', 'garnet'],
  ['eat', 'east', 'steak', 'basket'],
  ['ear', 'dear', 'armed', 'marked'],
  ['are', 'real', 'ariel', 'aerial'],
  ['ate', 'date', 'acted', 'traced'],
  ['tea', 'tale', 'least', 'castle'],
  ['eat', 'date', 'fated', 'defeat'],
  ['ear', 'dare', 'grade', 'garden'],
  ['are', 'dear', 'dream', 'admire'],
  ['ate', 'rate', 'crate', 'carpet'],
  ['tea', 'east', 'waste', 'sweaty'],
  ['eat', 'late', 'least', 'castle'],
  ['ear', 'rage', 'range', 'garden'],
  ['are', 'gear', 'grace', 'charge'],
  ['ate', 'take', 'skate', 'casket'],
  ['tea', 'date', 'trade', 'hatred'],
  ['eat', 'mate', 'metal', 'amulet'],
  ['ear', 'care', 'cater', 'cartel'],
  ['are', 'read', 'tread', 'thread'],
  ['ear', 'race', 'racer', 'career'],
  ['are', 'bare', 'beard', 'barbed'],
  ['ear', 'fear', 'flare', 'falter'],
  ['are', 'tear', 'alert', 'travel'],
  ['ear', 'dare', 'aired', 'admire'],
  ['are', 'earl', 'glare', 'larger'],
  ['ear', 'earn', 'range', 'danger'],
  ['are', 'tear', 'earth', 'father'],
  ['ear', 'rate', 'eater', 'repeat'],
  ['are', 'earl', 'laser', 'serial'],
  ['ear', 'dear', 'bread', 'badger'],
  ['are', 'read', 'armed', 'admire'],
  ['ear', 'tear', 'trace', 'carpet'],
  ['are', 'rage', 'great', 'garnet'],
  ['ear', 'read', 'adore', 'adored'],
  ['are', 'bare', 'rehab', 'breath'],
  ['ear', 'dare', 'raced', 'scared'],
  ['are', 'rate', 'heart', 'father'],
  ['ear', 'fear', 'after', 'father'],
  ['are', 'near', 'learn', 'learnt'],
  ['ear', 'dear', 'dread', 'traded'],
  ['are', 'tear', 'heart', 'rather'],
  ['ear', 'gear', 'eager', 'reggae'],
  ['are', 'earl', 'alter', 'travel'],
  ['ear', 'rate', 'cater', 'carpet'],
  ['are', 'dare', 'armed', 'framed'],
  ['ear', 'read', 'cared', 'dancer'],
  ['are', 'tear', 'cater', 'traced'],
  ['ear', 'race', 'crane', 'cancer'],
  ['are', 'earl', 'flare', 'raffle'],
  ['ear', 'near', 'anger', 'german'],
  ['are', 'read', 'dared', 'traded'],
  ['ear', 'earl', 'large', 'gravel'],
  ['are', 'real', 'clear', 'cellar'],
  ['ear', 'read', 'trade', 'dreamt'],
  ['are', 'real', 'flare', 'raffle'],
  ['ear', 'bare', 'barge', 'barged'],
  ['are', 'care', 'cedar', 'dancer'],
  ['ear', 'race', 'cream', 'camera'],
  ['are', 'hear', 'heard', 'harder'],
  ['ear', 'read', 'dread', 'ladder'],
  ['are', 'vera', 'carve', 'carved'],
  ['ear', 'care', 'cedar', 'dancer'],
  ['are', 'dare', 'adore', 'reload'],
  ['ear', 'dear', 'raced', 'dancer'],
  ['are', 'care', 'cared', 'sacred'],
  ['ear', 'rate', 'crate', 'racket'],
  ['are', 'race', 'carve', 'carved'],
  ['ear', 'bare', 'zebra', 'blazer'],
  ['are', 'read', 'cedar', 'scared'],
  ['ear', 'tear', 'terra', 'barter'],
  ['are', 'year', 'early', 'lawyer'],
  ['ear', 'tear', 'earth', 'father'],
  ['are', 'tear', 'later', 'albert'],
  ['ear', 'earl', 'alert', 'taller'],
  ['are', 'vera', 'brave', 'beaver'],
  ['ear', 'bear', 'bread', 'barged'],
  ['are', 'care', 'cream', 'camera'],
  ['ear', 'gear', 'grade', 'danger'],
  ['are', 'real', 'later', 'travel'],
  ['ear', 'earn', 'anger', 'german'],
  ['are', 'dare', 'ready', 'dreamy'],
  ['ear', 'real', 'glare', 'gravel'],
  ['are', 'rear', 'terra', 'artery'],
  ['ear', 'bare', 'break', 'banker'],
  ['are', 'read', 'dream', 'marked'],
  ['ear', 'rate', 'alter', 'learnt'],
  ['are', 'bare', 'brake', 'barker'],
  ['ear', 'rate', 'grate', 'gather'],
  ['are', 'real', 'realm', 'palmer'],
  ['ear', 'wear', 'swear', 'answer'],
  ['are', 'rate', 'rated', 'thread'],
  ['ear', 'real', 'learn', 'nearly'],
  ['are', 'dear', 'raced', 'dancer'],
  ['ear', 'rage', 'lager', 'larger'],
  ['are', 'race', 'recap', 'preach'],
  ['ear', 'near', 'yearn', 'nearly'],
  ['are', 'dear', 'heard', 'shared'],
  ['ear', 'bare', 'amber', 'marble'],
  ['are', 'dear', 'aired', 'raised'],
  ['ear', 'rare', 'terra', 'rather'],
  ['are', 'rage', 'grade', 'agreed'],
  ['ear', 'hear', 'heard', 'harder'],
  ['are', 'dear', 'tread', 'dreamt'],
  ['ear', 'rate', 'alert', 'albert'],
  ['are', 'rate', 'react', 'create'],
  ['ear', 'read', 'rated', 'traced'],
  ['are', 'rate', 'after', 'faster'],
  ['ear', 'gear', 'large', 'larger'],
  ['tea', 'rate', 'extra', 'baxter'],
  ['ear', 'rare', 'racer', 'career'],
  ['are', 'earl', 'realm', 'palmer'],
  ['ear', 'real', 'pearl', 'player'],
  ['tea', 'rate', 'tread', 'hatred'],
  ['ear', 'tear', 'alert', 'travel'],
  ['tea', 'east', 'haste', 'hasten'],
  ['ear', 'care', 'crave', 'carver'],
  ['tea', 'tear', 'react', 'create'],
  ['ear', 'care', 'reach', 'search'],
  ['tea', 'date', 'delta', 'talked'],
  ['ear', 'dare', 'ready', 'dreamy'],
  ['are', 'care', 'clear', 'recall'],
  ['ear', 'wear', 'water', 'waiter'],
  ['are', 'rate', 'alert', 'albert'],
  ['ear', 'near', 'range', 'danger'],
  ['are', 'rage', 'lager', 'larger'],
  ['ear', 'dare', 'cared', 'carved'],
  ['are', 'dear', 'ready', 'dearly'],
  ['ear', 'earn', 'yearn', 'nearby'],
  ['are', 'real', 'glare', 'gravel'],
  ['tea', 'tear', 'eater', 'easter'],
  ['ear', 'race', 'carve', 'carved'],
  ['tea', 'team', 'steam', 'master'],
  ['ear', 'bear', 'brace', 'breach'],
  ['are', 'dare', 'dread', 'raided'],
  ['ear', 'race', 'recap', 'preach'],
  ['eat', 'seat', 'stare', 'master'],
  ['are', 'bear', 'barge', 'beggar'],
  ['ate', 'east', 'sweat', 'wasted'],
  ['are', 'race', 'crave', 'carver'],
  ['ear', 'tear', 'rated', 'hatred'],
  ['eat', 'east', 'stake', 'casket'],
  ['ear', 'rage', 'anger', 'danger'],
  ['are', 'bear', 'baker', 'bakery'],
  ['eat', 'seat', 'steam', 'stream'],
  ['tea', 'team', 'metal', 'hamlet'],
  ['are', 'race', 'react', 'cartel'],
  ['ate', 'seat', 'stare', 'master'],
  ['tea', 'seat', 'paste', 'aspect'],
  ['are', 'read', 'ready', 'dreary'],
  ['tea', 'seat', 'slate', 'stella'],
  ['eat', 'tale', 'slate', 'stable'],
  ['ate', 'seat', 'slate', 'stella'],
  ['ear', 'rate', 'rated', 'thread'],
  ['are', 'read', 'heard', 'hatred'],
  ['ear', 'year', 'ready', 'prayed'],
  ['tea', 'team', 'mater', 'matter'],
  ['eat', 'tear', 'later', 'albert'],
  ['tea', 'tape', 'taped', 'tapped'],
  ['ear', 'fear', 'frame', 'farmer'],
  ['are', 'race', 'cater', 'cartel'],
  ['ear', 'rage', 'glare', 'gravel'],
  ['ate', 'heat', 'bathe', 'bertha'],
  ['ear', 'vera', 'carve', 'carved'],
  ['are', 'read', 'beard', 'badger'],
  ['ate', 'rate', 'treat', 'matter'],
  ['tea', 'east', 'slate', 'castle'],
  ['ear', 'tear', 'crate', 'create'],
  ['ate', 'neat', 'eaten', 'beaten'],
  ['ear', 'year', 'layer', 'really'],
  ['tea', 'heat', 'heart', 'father'],
  ['are', 'dare', 'raced', 'scared'],
  ['tea', 'tear', 'alter', 'taller'],
  ['eat', 'late', 'plate', 'planet'],
  ['ear', 'care', 'cared', 'sacred'],
  ['are', 'bare', 'brace', 'breach'],
  ['tea', 'rate', 'rated', 'traced'],
  ['are', 'earl', 'ariel', 'aerial'],
  ['eat', 'heat', 'wheat', 'wealth'],
  ['are', 'read', 'cared', 'dancer'],
  ['ate', 'rate', 'after', 'faster'],
  ['ear', 'real', 'later', 'travel'],
  ['are', 'near', 'crane', 'dancer'],
  ['tea', 'tear', 'trace', 'crater'],
  ['are', 'care', 'racer', 'career'],
  ['ear', 'bear', 'baker', 'bakery'],
  ['are', 'earn', 'crane', 'dancer'],
  ['ate', 'tale', 'later', 'learnt'],
  ['eat', 'tear', 'react', 'create'],
  ['ate', 'mate', 'metal', 'amulet'],
  ['eat', 'date', 'dealt', 'detail'],
  ['are', 'care', 'scare', 'scared'],
  ['eat', 'east', 'slate', 'castle'],
  ['ate', 'tear', 'stare', 'faster'],
  ['eat', 'tear', 'treat', 'target'],
  ['are', 'gear', 'grate', 'target'],
  ['eat', 'east', 'yeast', 'steady'],
  ['are', 'rate', 'cater', 'carpet'],
  ['ate', 'east', 'tesla', 'salute'],
  ['eat', 'rate', 'treat', 'matter'],
  ['ate', 'east', 'feast', 'safety'],
  ['are', 'year', 'yearn', 'nearby'],
  ['ate', 'neat', 'meant', 'mental'],
  ['tea', 'beat', 'table', 'albert'],
  ['ate', 'seat', 'stale', 'lasted'],
  ['tea', 'east', 'yeast', 'steady'],
  ['eat', 'date', 'tamed', 'teamed'],
  ['tea', 'east', 'stake', 'casket'],
  ['are', 'hear', 'reach', 'charge'],
  ['tea', 'date', 'dated', 'traded'],
  ['eat', 'late', 'alert', 'albert'],
  ['tea', 'east', 'steak', 'basket'],
  ['are', 'dare', 'dared', 'adored'],
  ['ear', 'bare', 'brace', 'breach'],
  ['are', 'rear', 'racer', 'archer'],
  ['eat', 'east', 'caste', 'aspect'],
  ['are', 'race', 'creak', 'racket'],
  ['ear', 'care', 'scare', 'scared'],
  ['are', 'vera', 'crave', 'carver'],
  ['ear', 'rate', 'trace', 'cartel'],
  ['are', 'gear', 'anger', 'garden'],
  ['ear', 'bare', 'baker', 'bakery'],
  ['eat', 'date', 'dated', 'traded'],
  ['ear', 'fear', 'freak', 'freaky'],
  ['are', 'real', 'learn', 'nearly'],
  ['ate', 'neat', 'agent', 'magnet'],
  ['tea', 'date', 'tamed', 'teamed'],
  ['ate', 'tale', 'alert', 'taller'],
  ['tea', 'neat', 'atone', 'donate'],
  ['are', 'gear', 'grade', 'danger'],
  ['ear', 'dare', 'heard', 'thread'],
  ['are', 'hear', 'earth', 'rather'],
  ['ear', 'vera', 'crave', 'carver'],
  ['are', 'read', 'padre', 'parade'],
  ['ear', 'race', 'creak', 'racket'],
  ['are', 'dear', 'armed', 'marked'],
  ['ear', 'bare', 'rehab', 'breath'],
  ['eat', 'tear', 'after', 'fatter'],
  ['ear', 'care', 'crate', 'carpet'],
  ['tea', 'mate', 'meant', 'magnet'],
  ['ear', 'dare', 'tread', 'hatred'],
  ['ate', 'east', 'caste', 'aspect'],
  ['are', 'race', 'cream', 'camera'],
  ['tea', 'seat', 'caste', 'stance'],
  ['ear', 'earl', 'layer', 'lawyer'],
  ['tea', 'rate', 'great', 'gather'],
  ['ear', 'vera', 'brave', 'beaver'],
  ['eat', 'tear', 'mater', 'matter'],
  ['are', 'dear', 'drake', 'parked'],
  ['tea', 'east', 'taste', 'estate'],
  ['are', 'real', 'relay', 'barely'],
  ['eat', 'tear', 'alter', 'taller'],
  ['ear', 'rage', 'agree', 'grease'],
  ['eat', 'late', 'stale', 'salute'],
  ['ate', 'rate', 'rated', 'traced'],
  ['eat', 'late', 'table', 'battle'],
  ['ate', 'heat', 'heart', 'father'],
  ['eat', 'east', 'tease', 'senate'],
  ['ate', 'tear', 'trade', 'hatred'],
  ['eat', 'tear', 'eater', 'easter'],
  ['tea', 'tear', 'stare', 'faster'],
  ['eat', 'heat', 'bathe', 'bertha'],
  ['ear', 'read', 'heard', 'hatred'],
  ['eat', 'rate', 'trace', 'create'],
  ['ear', 'earl', 'clear', 'cellar'],
  ['tea', 'seat', 'stage', 'staged'],
  ['are', 'care', 'creak', 'racket'],
  ['ate', 'late', 'plate', 'planet'],
  ['are', 'race', 'racer', 'career'],
  ['eat', 'east', 'taste', 'estate'],
  ['are', 'dear', 'padre', 'spread'],
  ['ate', 'east', 'stake', 'casket'],
  ['ear', 'earl', 'glare', 'larger'],
  ['eat', 'rate', 'water', 'waiter'],
  ['ear', 'dare', 'trade', 'traced'],
  ['ate', 'take', 'stake', 'basket'],
  ['ear', 'read', 'tread', 'thread'],
  ['tea', 'rate', 'stare', 'breast'],
  ['ear', 'tear', 'cater', 'traced'],
  ['are', 'dear', 'grade', 'danger'],
  ['ate', 'mate', 'meant', 'magnet'],
  ['are', 'gear', 'range', 'german'],
  ['ate', 'neat', 'atone', 'donate'],
  ['are', 'rage', 'sarge', 'greasy'],
  ['ate', 'seat', 'waste', 'wasted'],
  ['eat', 'fate', 'fated', 'farted'],
  ['ear', 'dear', 'beard', 'barbed'],
  ['ate', 'late', 'metal', 'mental'],
  ['are', 'earn', 'learn', 'nearly'],
  ['eat', 'heat', 'theta', 'threat'],
  ['tea', 'date', 'rated', 'thread'],
  ['eat', 'rate', 'earth', 'father'],
  ['ate', 'rate', 'earth', 'father'],
  ['eat', 'seat', 'state', 'estate'],
  ['are', 'bear', 'beard', 'barred'],
  ['eat', 'seat', 'taste', 'statue'],
  ['tea', 'rate', 'grate', 'target'],
  ['are', 'gear', 'sarge', 'grease'],
  ['ate', 'late', 'alert', 'albert'],
  ['are', 'rate', 'grate', 'gather'],
  ['ate', 'seat', 'least', 'latest'],
  ['are', 'bare', 'barge', 'barged'],
  ['ate', 'tear', 'great', 'garret'],
  ['ear', 'care', 'creak', 'racket'],
  ['tea', 'tale', 'alter', 'travel'],
  ['ear', 'race', 'crave', 'carver'],
  ['ate', 'mate', 'mater', 'master'],
  ['ear', 'read', 'dream', 'marked'],
  ['eat', 'tear', 'trace', 'crater'],
  ['are', 'wear', 'weary', 'lawyer'],
];